import React, { useContext, useEffect, useState } from 'react';
import {
  default_country_code,
  features,
  language
} from '../config';
import { useDispatch, useSelector } from "react-redux";

import AlertDialog from '../components/AlertDialog';
import Button from "../components/CustomButtons/Button.js";
import Card from "../components/Card/Card.js";
import CardBody from "../components/Card/CardBody.js";
import CardFooter from "../components/Card/CardFooter.js";
import CountrySelect from '../components/CountrySelect';
import CustomInput from "../components/CustomInput/CustomInput.js";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Email from "@mui/icons-material/Email";
import EmailIcon from '@mui/icons-material/Email';
import Footer from "../components/Footer/Footer.js";
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";
import HeaderLogo from "../components/Header/HeaderLogo.js";
import HeaderTransparent from "../components/Header/HeaderTransparent.js";
import Icon from "@mui/material/Icon";
import InputAdornment from "@mui/material/InputAdornment";
import Paper from '@mui/material/Paper';
import PhoneIcon from '@mui/icons-material/Phone';
import { Button as RegularButton } from "@mui/material";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import image from "../assets/img/background.jpg";
import { makeStyles } from "@mui/styles";
import styles from "../assets/jss/material-kit-react/views/loginPage.js";
import Firebase from '../api/Firebase';
import { useParams } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  // const { api, RecaptchaVerifier } = useContext(FirebaseContext);
  const { api, RecaptchaVerifier } = Firebase;
  const {
    signIn,
    // facebookSignIn,
    clearLoginError,
    sendResetMail,
    checkUserExists,
    authRef,
    mobileSignIn,
    signOut,
    requestPhoneOtpDevice,
    resetPassword
  } = api;

  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [loginType, setLoginType] = React.useState(0);
  const [activeReg, setActiveReg] = React.useState(false);
  const [openFPModal, setOpenFPModal] = React.useState(false);
  const [capatchaReady, setCapatchaReady] = React.useState(false);

  const [data, setData] = React.useState({
    email: '',
    pass: '',
    country: default_country_code.phone,
    mobile: '',
    password: '',
    otp: '',
    verificationId: null,
    firstName: '',
    lastName: '',
    selectedcountry: default_country_code,
    usertype: 'rider',
    referralId: ''
  });

  const [password, setPassword] = useState({
    password: '',
    confirmPassword: ""
  })

  const [tabDisabled, setTabDisabled] = React.useState(false);
  const [fpEmail, setFpEmail] = React.useState("");

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const { token } = useParams();

  const classes = useStyles();
  const { ...rest } = props;

  useEffect(() => {
    // if (!capatchaReady) {
    //   window.recaptchaVerifier = new RecaptchaVerifier("sign-in-button", {
    //     'size': 'invisible',
    //     'callback': function (response) {
    //       setCapatchaReady(true);
    //     }
    //   });
    // }
    if (auth.info) {
      if (auth.info.profile) {
        let role = auth.info.profile.usertype;
        if (role === 'admin' || role === 'fleetadmin') {
          props.history.push('/dashboard');
        }
        else if (role === 'driver') {
          props.history.push('/profile');
        }
        else {
          features.WebsitePagesEnabled ? props.history.push('/') : props.history.push('/profile');
        }
      } else {
        if (!activeReg) {
          setActiveReg(true);
          if (auth.info.phoneNumber) {
            setData({ ...data, mobile: auth.info.phoneNumber })
            setLoginType(1);

          } else {
            setData({ ...data, email: auth.info.email })
            setLoginType(0);
          }
          setTabDisabled(true);
          setCommonAlert({ open: true, msg: language.login_success });
        }
      }
    }
    if (auth.error && auth.error.flag && auth.error.msg.message !== language.not_logged_in) {
      setCommonAlert({ open: true, msg: auth.error.msg.message })
    }
    if (auth.verificationId) {
      setData({ ...data, verificationId: auth.verificationId });
    }
  }, [auth.info, auth.error, auth.verificationId, props.history, data, data.email, activeReg, capatchaReady, RecaptchaVerifier]);

  const handleTabChange = (event, newValue) => {
    setLoginType(newValue);
  };

  // const handleFacebook = (e) => {
  //   e.preventDefault();
  //   dispatch(facebookSignIn());
  // }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' });
    if (auth.error.flag) {
      setData({ ...data, email: '', pass: '' });
      dispatch(clearLoginError());
    }
  };

  const onInputChange = (event) => {
    setData({ ...data, [event.target.id]: event.target.value })
  }

  const onPasswordChange = (event) => {
    const { id, value } = event.target;
    setPassword({ ...password, [id]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    //eslint-disable-next-line
    if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data.email) && data.pass.length > 0) {
      dispatch(signIn(data.email, data.pass));
    } else {
      setCommonAlert({ open: true, msg: language.login_validate_error })
    }
    setData({ ...data, email: '', pass: '' });
  }

  const handleGetOTP = (e) => {
    e.preventDefault();
    const phoneNumber = "+" + data.country + data.mobile;
    checkUserExists({ mobile: phoneNumber }).then((res) => {
      if (res.success) {
        if (res.data) {
          requestPhoneOtpDevice(phoneNumber).then((res) => {
            if (res.success) {
              setData({ ...data, verificationId: res.verificationId })
            } else {
              setCommonAlert({ open: true, msg: res.message })
            }
          });
        } else {
          setCommonAlert({ open: true, msg: language.user_does_not_exists })
        }
      } else {
        setCommonAlert({ open: true, msg: res.message })
      }
    });
  }

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    if (data.otp.length === 6 && parseInt(data.otp) > 100000 & parseInt(data.otp) < 1000000) {
      dispatch(mobileSignIn("+" + data.country + data.mobile, data.otp));
    } else {
      setCommonAlert({ open: true, msg: language.otp_validate_error })
    }
  }

  const handleCancel = (e) => {
    e.preventDefault();
    dispatch(signOut());
    setTabDisabled(false);
    setActiveReg(false);
  }

  const onCountryChange = (object, value) => {
    if (value && value.phone) {
      setData({ ...data, country: value.phone, selectedcountry: value });
    }
  };

  const handleRegister = (e) => {
    props.history.push('/register');
  };

  const handleForgotPass = (e) => {
    e.preventDefault();
    setOpenFPModal(true);
  };

  const onFPModalEmailChange = (e) => {
    e.preventDefault();
    setFpEmail(e.target.value);
  }

  const handleCloseFP = (e) => {
    e.preventDefault();
    setFpEmail('');
    setOpenFPModal(false);
  }

  const handleResetPassword = (e) => {
    e.preventDefault();
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!fpEmail || !re.test(fpEmail)) {
      setCommonAlert({ open: true, msg: "Please enter a valid email" });
      return;
    }
    dispatch(sendResetMail(fpEmail));
    setFpEmail('');
    setOpenFPModal(false);
  }

  const resetEmailPassword = async (e) => {
    e.preventDefault();
    if (!password.password || !password.confirmPassword) {
      setCommonAlert({ open: true, msg: "Please fill all the fields!" });
      return;
    }
    if (password.password !== password.confirmPassword) {
      setCommonAlert({ open: true, msg: "Password and confirm password did not match" });
      return;
    }
    const res = await resetPassword(password.password, token);
    setCommonAlert({ open: true, msg: res.message });
    props.history.push('/login');
    // if (res.success) {

    // } else {
    //   setCommonAlert({ open: true, msg: res.message })
    // }
  }

  return (
    <div>
      <HeaderLogo
        absolute
        color="transparent"
        rightLinks={<HeaderTransparent />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div id="sign-in-button" />
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <form className={classes.form}>
                  {/* {features.FacebookLoginEnabled ?
                    <CardHeader color="info" className={classes.cardHeader}>
                      <h4>{language.signIn}</h4>
                      <div className={classes.socialLine}>
                        {features.FacebookLoginEnabled ?
                          <Button
                            justIcon
                            href="#pablo"
                            target="_blank"
                            color="transparent"
                            onClick={handleFacebook}
                          >
                            <i className={"fab fa-facebook"} />
                          </Button>
                          : null}
                      </div>
                    </CardHeader>
                    : null} */}
                  <Paper square className={classes.root} style={!(features.FacebookLoginEnabled) ? { paddingTop: 20, borderTopLeftRadius: 10, borderTopRightRadius: 10 } : null}>
                    {!token ?
                      <Tabs
                        value={loginType}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="inherit"
                        aria-label="switch login type"
                      >
                        <Tab disabled={tabDisabled} icon={<EmailIcon />} label={language.email_tab} aria-label="email" />
                        {features.MobileLoginEnabled ?
                          <Tab disabled={tabDisabled} icon={<PhoneIcon />} label={language.phone_tab} aria-label="phone" />
                          : null}
                      </Tabs>
                      :
                      <Tabs
                        value={loginType}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="inherit"
                        aria-label="switch login type"
                      >
                        <Tab icon={<EmailIcon />} label={"Reset Password"} aria-label="reset" />

                      </Tabs>
                    }

                  </Paper>

                  <CardBody>
                    {token ?
                      <>
                        <CustomInput
                          labelText={"Password"}
                          id="password"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "password",
                            required: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Icon className={classes.inputIconsColor}>
                                  lock_outline
                                </Icon>
                              </InputAdornment>
                            )
                          }}
                          onChange={onPasswordChange}
                          value={password.password}
                        />
                        <CustomInput
                          labelText={"Confirm Password"}
                          id="confirmPassword"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type: "password",
                            required: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Icon className={classes.inputIconsColor}>
                                  lock_outline
                                </Icon>
                              </InputAdornment>
                            )
                          }}
                          onChange={onPasswordChange}
                          value={password.confirmPassword}
                        />
                      </>
                      :
                      <>
                        {loginType === 0 ?    //EMAIL
                          <CustomInput
                            labelText={language.email}
                            id="email"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "email",
                              required: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Email className={classes.inputIconsColor} />
                                </InputAdornment>
                              )
                            }}
                            onChange={onInputChange}
                            value={data.email}
                          />
                          : null}
                        {loginType === 0 ?
                          <CustomInput
                            labelText={language.password}
                            id="pass"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "password",
                              required: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Icon className={classes.inputIconsColor}>
                                    lock_outline
                                  </Icon>
                                </InputAdornment>
                              ),
                              autoComplete: "off"
                            }}
                            onChange={onInputChange}
                            value={data.pass}
                          />
                          : null}
                        {loginType === 1 && features.AllowCountrySelection ?   // COUNTRY
                          <CountrySelect
                            value={data.selectedcountry}
                            onChange={onCountryChange}
                            style={{ paddingTop: 20 }}
                            disabled={data.verificationId ? true : false}
                          />
                          : null}
                        {loginType === 1 ?   //MOBILE
                          <CustomInput
                            labelText={language.phone}
                            id="mobile"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              disabled: data.verificationId ? true : false,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <PhoneIcon className={classes.inputIconsColor} />
                                </InputAdornment>
                              )
                            }}
                            onChange={onInputChange}
                            value={data.mobile}
                          />
                          : null}
                        {data.verificationId && loginType === 1 ?    // OTP
                          <CustomInput
                            labelText={language.otp}
                            id="otp"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "password",
                              required: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Icon className={classes.inputIconsColor}>
                                    lock_outline
                                  </Icon>
                                </InputAdornment>
                              ),
                              autoComplete: "off"
                            }}
                            onChange={onInputChange}
                            value={data.otp}
                          />
                          : null}
                        {loginType === 0 ?
                          <RegularButton
                            color="inherit"
                            onClick={handleForgotPass}
                            disableElevation={true}
                            disableFocusRipple={true}
                            disableRipple={true}
                            className={classes.forgotButton}
                            variant="text"
                          >
                            {language.forgot_password}
                          </RegularButton>
                          : null}
                      </>
                    }
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    {!token ?
                      <>
                        {loginType === 0 ?
                          <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleSubmit}>
                            {language.login}
                          </Button>
                          : null}
                        {loginType === 0 ?
                          <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleRegister}>
                            {language.register}
                          </Button>
                          : null}

                        {loginType === 1 && !data.verificationId ?
                          <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleGetOTP}>
                            {language.get_otp}
                          </Button>
                          : null}
                        {loginType === 1 && data.verificationId ?
                          <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleVerifyOTP}>
                            {language.verify_otp}
                          </Button>
                          : null}

                        {loginType === 1 && data.verificationId ?
                          <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleCancel}>
                            {language.cancel}
                          </Button>
                          : null}
                      </>
                      :
                      <Button className={classes.normalButton} simple color="primary" size="lg" onClick={resetEmailPassword}>
                        Reset
                      </Button>
                    }
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        {/* <Footer whiteFont /> */}
        <Dialog open={openFPModal} onClose={handleCloseFP} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{language.forgot_pass_title}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {language.forgot_pass_description}
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label={language.email}
              type="email"
              fullWidth
              onChange={onFPModalEmailChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseFP} color="primary">
              {language.cancel}
            </Button>
            <Button onClick={handleResetPassword} color="primary">
              {language.reset_password}
            </Button>
          </DialogActions>
        </Dialog>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
      <Footer />
    </div>
  );
}